import React from 'react';
import { withRouter, useHistory, useParams, useLocation, useRouteMatch } from 'react-router';
import { getQueryString } from '../../../utils/common';
import './index.scss';
const CopyrightNotice = props => {
	let history = useHistory();
	let title = decodeURIComponent(getQueryString('title') || '');
	return (
		<div className="copyright copyright-about">
			{/* // <!-- 头部导航栏 开始 --> */}
			<header className="nav-header-container">
				<div className="back">
					<span className="icon"></span>
					<label
						onClick={() => {
							history.goBack();
						}}>
						返回
					</label>
				</div>
				<span className="title">版权声明</span>
			</header>
			{/* // <!-- 头部导航栏 结束 -->
            // <!-- 正文内容 开始 --> */}
			<section className="main-content">
				<div className="set-details-container">
					<p>
						为更好地服务与推动中国图片市场和文化创意产业的健康发展，呼吁社会各界尊重原创作者的劳动成果，制止非法图片转载行为或其他图片版权侵权行为，共同维护和促进国内图片版权市场的健康有序及可持续发展，投图在此郑重声明如下：
					</p>
					<p>1. 疫情期间图片使用均为公益免费；</p>
					<p>2. 用于文章配图，请务必注明“图片来源：VPHOTO投图 摄影师 XXX”；</p>
					<p>3. 用于其他渠道单独使用，如banner图、H5配图、APP内等，请于明显、恰当位置（图片角标、专题内页等）注明“图片来源：VPHOTO投图 摄影师 XXX”；</p>
					<p>4. 图片使用包括但不限于媒体文章配图页面、媒体各对外渠道配图、媒体相关微博、此主题相关新闻稿件报道等等，不得将图片用于一切涉及恶意攻击、谩骂及煽动诋毁性用途。</p>
					<p>5. 如因使用图片对上传者、照片中人物或涉及品牌等、VPHOTO、投图、相关征集方造成肖像权、名誉权、著作权等法律责任和相关损失，将由使用者全部承担；</p>
					<p>6. 本次征集最终解释权归投图所有。</p>
				</div>
			</section>
			{/* // <!-- 正文内容 结束 --> */}
		</div>
	);
};
export { CopyrightNotice };
